import React from 'react';
import { Container } from 'react-bootstrap';
import YouTube from 'react-youtube';

const VideoPlayer: React.FC = () => {
  // YouTube video ID
  const videoId = '2kN7_-LHNhs';

  // Options for the YouTube player
  const opts = {
    height: '390',
    width: '100%',
    playerVars: {
      // https://developers.google.com/youtube/player_parameters
      autoplay: 0,
    },
  };

  // Handle when the video player is ready
  const onReady = (event: any) => {
    // access to player in all event handlers via event.target
    event.target.pauseVideo();
  };

  return (
    <Container className=' mt-5 justify-center flex mx-auto text-center'>

        <YouTube videoId={videoId} opts={opts} onReady={onReady} />
    </Container>
  );
};

export default VideoPlayer;
